<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="companyText"
    item-value="companyCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartSupplierInput',

  mixins: [APIUtils, Message],
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    partCd: {
      type: String,
      required: true,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0002')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    isSearchByLoginCompany: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  watch: {
    async partCd(value) {
      await this.setSupplierParts(value)
    },
  },

  methods: {
    async setSupplierParts(partCd) {
      this.loading = true
      this.items = []

      try {
        let params = { partCd: partCd }

        if (this.isSearchByLoginCompany) {
          params.userCompanyCd = this.$store.getters.companyCd
        }

        if (this.validOnly) {
          params.validOnly = true
        }

        const elements = await API.get('/master/partSuppliers', params)
        this.items = []
        elements.forEach((element) => {
          element['companyText'] = element['companyCd'] + ' : ' + element['companyName']
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setSupplierParts(this.partCd)
  },
}
</script>
